module.exports = __webpack_public_path__ + "img/Apron.15193768.png";